import { mask } from './mask';
import { listener } from './listener';
export const build = ({
  input,
  options
}) => {
  const ms = mask(options);
  return listener(input, target => ms.updateSelection(target), target => ms.processChange(target), target => ms.setPlaceholder(target), target => ms.clearPlaceholder(target));
};